import { cities } from "@api/geo/cities/path";
import { countries } from "@api/geo/countries/path";
import { currencies } from "@api/geo/currencies/path";
import { states } from "@api/geo/states/path";

export const geo = {
  currencies,
  countries,
  cities,
  states,
};
